<template>
  <b-overlay :show="loading" rounded="sm" spinner-variant="primary"  opacity="0.25">
    <p class="my-3">선택하신 항목을 PDF 문서로 다운로드 합니다.</p>
    <div v-for="(lv1_info, lv1_idx) in sb_toc" :key="lv1_idx">
      <b-form-checkbox class="mb-3" v-model="selected" :value="lv1_info">
        {{ lv1_info.name }}
      </b-form-checkbox>
    </div>

    <b-form-invalid-feedback :state="state">목차를 하나 이상 선택해주세요!</b-form-invalid-feedback>
    <div class="text-left mt-4">
      <b-button
        :disabled="!state"
        variant="teal"
        v-print="{
          id: '#full-report-preview-sb',
          popTitle: popTitle,
          selectedLv1PrintOption: selected
        }"
        v-b-tooltip.hover
        :title="lang != 'ENG' ? '출력하기' : 'Print to PDF'"
        @click="handleDownload"
      >
        PDF 다운로드
      </b-button>
      <b-button variant="secondary" class="ml-2" @click="closePrintOption"> 취소 </b-button>
    </div>
  </b-overlay>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from 'vuex';

  export default {
    name: 'SbPrintOption',
    computed: {
      ...mapState('report_list', ['lang']),
      ...mapGetters('report_list', ['selected_report']),
      ...mapGetters('story_board', ['sb_toc']),
      state() {
        return this.selected.length > 0;
      },
      popTitle() {
        if (this.lang === 'KOR') {
          return this.selected_report.report_name;
        } else {
          return this.selected_report.report_name_e
        }
      },
    },
    data() {
      return {
        selected: [],
        loading: false, 
      };
    },

    watch: {
      sb_toc: {
        immediate: true,
        handler() {
          this.selected = JSON.parse(JSON.stringify(this.sb_toc))
        },
      },
    },
    methods: {
      ...mapMutations('story_board', ['update_print_option']),
      closePrintOption() {
        this.$store.commit('story_board/update_print_mode', false)
        this.$bvModal.hide('story-board-modal');
      },

      handleDownload() {
        this.loading = true;
        this.update_print_option(this.selected);

        setTimeout(() => {
          this.loading = false;
        }, 10000);
      }
    },
  };
</script>

<style>
</style>
